"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const baseValues_1 = __importDefault(require("../baseValues/baseValues"));
const BaseContent = ({ loanData }) => (react_1.default.createElement(react_native_1.View, null,
    react_1.default.createElement(baseValues_1.default, { loanData: loanData })));
exports.default = BaseContent;
